"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var useCarousel_1 = require("../hooks/useCarousel");
var carouselAnimator_1 = require("./carouselAnimator");
var carouselNavigation_1 = require("./carouselNavigation");
var interaction_1 = require("./interaction");
exports.CarouselContext = react_1.createContext({});
/**
 * React Component for displaying a list of slides.
 * Responsible for navigation, and state management, it will report back to
 * the container interaction that it has been completed
 */
exports.Carousel = function (_a) {
    var children = _a.children;
    var ctx = useCarousel_1.useCarousel(children.length, 0);
    var _b = ctx.state, current = _b.current, count = _b.count;
    var interaction = react_1.useContext(interaction_1.InteractionContext);
    react_1.useEffect(function () {
        if (current === count - 1) {
            interaction.complete();
        }
    }, [current, count]);
    return (react_1.default.createElement(exports.CarouselContext.Provider, { value: ctx },
        react_1.default.createElement(creator_ui_1.Box, { py: "20px", position: "relative", style: { boxSizing: "content-box" } },
            react_1.default.createElement(carouselAnimator_1.CarouselAnimator, null, children)),
        react_1.default.createElement(carouselNavigation_1.CarouselNavigation, null),
        react_1.default.createElement("div", { style: { display: "none" }, "aria-live": "polite", "aria-atomic": "true" },
            "Slide ",
            current,
            " of ",
            count)));
};
exports.Carousel.displayName = "Carousel";
